import { configureStore } from "@reduxjs/toolkit";
import { userReducer } from "./slices/UserSlice";
import clientsReducer from '../features/clients/clientsSlice'
import clientsReducerPage from '../features/clients/clientsSlicePage'
import contactsReducerPage from '../features/contacts/contactsSlicePage'
import repairsReducerPage from '../features/repairs/repairsSlicePage'

import contactsReducer from '../features/contacts/contactsSlice'
import repairsReducer from '../features/repairs/repairsSlice'
import clientsReducer3 from '../features/clients/WagonClientsSlice'
import contactsReducer3 from '../features/contacts/WagonContactsSlice'
import wagonTypesReducer from '../features/wagontype/wagonTypeSlice'
import requestTypesReducer from '../features/requesttype/requestTypeSlice'

import {repairRequestReducer} from '../features/repairs/createNewRepairSlice';

import { repairRequestReducerID } from '../features/repairs/repairsSliceID'
import { contactRequestReducerID } from "src/features/contacts/contactsSliceID";
import { contactRequestReducer } from "src/features/contacts/createNewContactSlice";
import {mapSliceNavi} from "src/features/map/mapSlice";


export const store = configureStore({
    reducer: {
        user: userReducer,
        clients: clientsReducer, 
        clientsPage: clientsReducerPage, 
        contactsPage: contactsReducerPage, 
        repairsPage: repairsReducerPage, 
        contacts: contactsReducer,
        repairs: repairsReducer, 
        clients3: clientsReducer3, 
        contacts3: contactsReducer3,
        wagontypes: wagonTypesReducer,
        requesttypes: requestTypesReducer,
        repair_request: repairRequestReducer,
        repair_requestID: repairRequestReducerID,
        contact_request: contactRequestReducer,
        contact_requestID: contactRequestReducerID,
        map: mapSliceNavi,
    },
    middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;